export default {
  methods: {
    logContentView: function (projectID, routeName, utmSource) {
      // dont track content views for logged out users
      // don't track content views when we are in become mode
      if (this.isLoggedIn && !this.wasAdmin) {
        const trackingData = {
          boardID: projectID,
          name: routeName,
          utmSource: utmSource
        }
        this.$store.dispatch('trackContentView', trackingData)
      }
    }
  }
}
